import { render, staticRenderFns } from "./DocumentProductionIndex.vue?vue&type=template&id=56b9962a&scoped=true"
import script from "./DocumentProductionIndex.vue?vue&type=script&lang=js"
export * from "./DocumentProductionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b9962a",
  null
  
)

export default component.exports